export default __webpack_public_path__ + "static/media/sort-down.273b85a2.svg";